var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%", outlined: "" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-expansion-panels",
        {
          staticClass: "mb-4",
          attrs: { flat: "" },
          model: {
            value: _vm.managementPanelExpanded,
            callback: function ($$v) {
              _vm.managementPanelExpanded = $$v
            },
            expression: "managementPanelExpanded",
          },
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c(
                "v-expansion-panel-header",
                { staticClass: "blue-grey lighten-5" },
                [
                  _c(
                    "div",
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-cog-outline"),
                      ]),
                      _c("strong", [_vm._v("Management")]),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "v-expansion-panel-content",
                [_c("c-pre-release-management")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        staticStyle: { width: "100%" },
        attrs: {
          "fixed-header": "",
          items: _vm.configs,
          headers: _vm.headers,
          "hide-default-footer": "",
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "disable-pagination": "",
        },
        on: {
          "update:sortBy": function ($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function ($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function ($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function ($event) {
            _vm.sortDesc = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.branch.name",
            fn: function ({ item }) {
              return [
                _c(
                  "v-card-text",
                  { staticClass: "accent--text subtitle-2 ma-0 pa-0" },
                  [_vm._v(_vm._s(item.branch.name))]
                ),
              ]
            },
          },
          {
            key: "item.config.group",
            fn: function ({ item }) {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "orange--text subtitle-2",
                                      attrs: {
                                        disabled: !_vm.ifCanEditConfigTag(),
                                        outlined: "",
                                        small: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressEditGroup(
                                            item.config
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(" " + _vm._s(item.config.group) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(item.config.group))])]
                ),
              ]
            },
          },
          {
            key: "item.config.tag",
            fn: function ({ item }) {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "green--text subtitle-2",
                                      attrs: {
                                        disabled: !_vm.ifCanEditConfigTag(),
                                        outlined: "",
                                        small: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressEditTag(item.config)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getTagText(item.config.tag)) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(item.config.tag))])]
                ),
              ]
            },
          },
          {
            key: "item.config.sharedConfig",
            fn: function ({ item }) {
              return [
                _vm.getSharedConfigName(item.config)
                  ? _c(
                      "v-chip",
                      {
                        attrs: {
                          small: "",
                          color: "purple",
                          "text-color": "white",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getSharedConfigName(item.config)) +
                            " "
                        ),
                      ]
                    )
                  : _c("span", { staticClass: "grey--text" }, [_vm._v("—")]),
              ]
            },
          },
          {
            key: "item.config.meta.uid",
            fn: function ({ item }) {
              return [
                _c(
                  "v-card-text",
                  { staticClass: "blue--text subtitle-2 ma-0 pa-0" },
                  [_vm._v(_vm._s(_vm.getOwner(item.config)))]
                ),
              ]
            },
          },
          {
            key: "item.config.meta.updated",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("formatDate")(_vm.getUpdated(item.config))) +
                    " "
                ),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "", "max-width": "50%" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        loading: _vm.loading == item.config.uid,
                                        icon: "",
                                        color: "orange",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressInfo(item.config)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-information"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          item.config.info?.length > 0
                            ? item.config.info
                            : "no info"
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          !_vm.ifCanCopyConfigToMyConfigs(),
                                        icon: "",
                                        color: "teal lighten-1",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressCopy(item.config)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-content-copy"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Copy to My Configs")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "white--text ma-0 pa-0",
                                      attrs: {
                                        loading: _vm.loading == item.config.uid,
                                        elevation: "0",
                                        small: "",
                                        color: "blue",
                                        disabled:
                                          true ||
                                          item.config.deployed == true ||
                                          !_vm.ifCanDeployConfigToStorage(),
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDeploy(item.config)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-0",
                                      attrs: { size: "22" },
                                    },
                                    [_vm._v("mdi-database-arrow-right-outline")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Deploy to storage")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "white--text ma-0 pa-0",
                                      attrs: {
                                        loading: _vm.loading == item.config.uid,
                                        elevation: "0",
                                        small: "",
                                        color: "blue",
                                        disabled:
                                          true ||
                                          item.config.deployed == true ||
                                          !_vm.ifCanDeployConfigToStorage(),
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDeployWithMerge(
                                            item.config
                                          )
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-0",
                                      attrs: { size: "22" },
                                    },
                                    [_vm._v("mdi-database-refresh-outline")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Deploy to storage with replace")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        loading: _vm.loading == item.config.uid,
                                        icon: "",
                                        color: "red",
                                        disabled: !_vm.ifCanEditConfigTag(),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDelete(item.config)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-delete"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Delete config")])]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }